
// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JSX modules
import DeliveryOptionsForm from '../_utils/_delivery-options/delivery-options-form';

// -----------------------------------------------------------
class DeliveryOptionsFormWithCallback extends DeliveryOptionsForm {
  static propTypes = {
    ...DeliveryOptionsForm.propTypes,
    onChange: PropTypes.func.isRequired,
  };

  handleChange(option) {
    this.props.onChange(option);
  }
}

// -----------------------------------------------------------

export default DeliveryOptionsFormWithCallback;
